import panguFormPageHistory from './panguFormPageHistory'
export default panguFormPageHistory
